// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .leftBar {
  flex: 2 1;
  position: sticky;
  top: 70px;
  height: calc(100vh - 70px);
  overflow: scroll;
  background-color: white;
  color: #000;
}
@media (max-width: 480px) {
  .theme-light .leftBar {
    display: none;
  }
}
.theme-light .leftBar::-webkit-scrollbar {
  display: none;
}
.theme-light .leftBar .container {
  padding: 20px;
}
.theme-light .leftBar .container hr {
  margin: 20px 0px;
  border: none;
  height: 0.5px;
  background-color: lightgray;
}
.theme-light .leftBar .container .menu {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.theme-light .leftBar .container .menu span {
  font-size: 12px;
}
.theme-light .leftBar .container .menu .user {
  display: flex;
  align-items: center;
  gap: 10px;
}
.theme-light .leftBar .container .menu .user a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #000;
  text-decoration: none;
}
.theme-light .leftBar .container .menu .user img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-light .leftBar .container .menu .user span {
  font-size: 14px;
}
.theme-light .leftBar .container .menu .item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.theme-light .leftBar .container .menu .item a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #000;
  text-decoration: none;
}
.theme-light .leftBar .container .menu .item img {
  width: 30px;
}
.theme-light .leftBar .container .menu .item span {
  font-size: 14px;
}
.theme-dark .leftBar {
  flex: 2 1;
  position: sticky;
  top: 70px;
  height: calc(100vh - 70px);
  overflow: scroll;
  background-color: #222;
  color: #fffef9;
}
@media (max-width: 480px) {
  .theme-dark .leftBar {
    display: none;
  }
}
.theme-dark .leftBar::-webkit-scrollbar {
  display: none;
}
.theme-dark .leftBar .container {
  padding: 20px;
}
.theme-dark .leftBar .container hr {
  margin: 20px 0px;
  border: none;
  height: 0.5px;
  background-color: #444;
}
.theme-dark .leftBar .container .menu {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.theme-dark .leftBar .container .menu span {
  font-size: 12px;
}
.theme-dark .leftBar .container .menu .user {
  display: flex;
  align-items: center;
  gap: 10px;
}
.theme-dark .leftBar .container .menu .user a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fffef9;
  text-decoration: none;
}
.theme-dark .leftBar .container .menu .user img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-dark .leftBar .container .menu .user span {
  font-size: 14px;
}
.theme-dark .leftBar .container .menu .item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.theme-dark .leftBar .container .menu .item a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fffef9;
  text-decoration: none;
}
.theme-dark .leftBar .container .menu .item img {
  width: 30px;
}
.theme-dark .leftBar .container .menu .item span {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/leftBar/leftBar.scss"],"names":[],"mappings":"AAqBI;ECjBA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAFJ;ADmCE;EAtBE;ICRE,aAAA;EADJ;AACF;AAGI;EACE,aAAA;AADN;AAII;EACE,aAAA;AAFN;AAIM;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;AAFR;AAKM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAHR;AAKQ;EACE,eAAA;AAHV;AAMQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAJV;AAMU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;AAJZ;AAMU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAJZ;AAOU;EACE,eAAA;AALZ;AASQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAPV;AASU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;AAPZ;AAUU;EACE,WAAA;AARZ;AAWU;EACE,eAAA;AATZ;ADnDI;ECjBA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AAuEJ;ADtCE;EAtBE;ICRE,aAAA;EAwEJ;AACF;AAtEI;EACE,aAAA;AAwEN;AArEI;EACE,aAAA;AAuEN;AArEM;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAuER;AApEM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAsER;AApEQ;EACE,eAAA;AAsEV;AAnEQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAqEV;AAnEU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;AAqEZ;AAnEU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAqEZ;AAlEU;EACE,eAAA;AAoEZ;AAhEQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAkEV;AAhEU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;AAkEZ;AA/DU;EACE,WAAA;AAiEZ;AA9DU;EACE,eAAA;AAgEZ","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.leftBar {\n  @include themify($themes) {\n    flex: 2;\n    position: sticky;\n    top: 70px;\n    height: calc(100vh - 70px);\n    overflow: scroll;\n    background-color: themed(\"bg\");\n    color: themed(\"textColor\");\n\n    @include mobile{\n      display: none;\n    }\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    .container {\n      padding: 20px;\n\n      hr {\n        margin: 20px 0px;\n        border: none;\n        height: 0.5px;\n        background-color: themed(\"border\");\n      }\n\n      .menu {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n\n        span {\n          font-size: 12px;\n        }\n\n        .user {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n\n          a {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            color: themed(\"textColor\");\n            text-decoration: none;\n          }\n          img {\n            width: 30px;\n            height: 30px;\n            border-radius: 50%;\n            object-fit: cover;\n          }\n\n          span {\n            font-size: 14px;\n          }\n        }\n\n        .item {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n\n          a {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            color: themed(\"textColor\");\n            text-decoration: none;\n          }\n\n          img {\n            width: 30px;\n          }\n\n          span {\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
